import React, { Fragment } from "react";
import { Container, Header, Icon, Segment } from "semantic-ui-react";

const UnderMaintenance = () => {
  return (
    <Segment inverted textAlign="center" vertical className="masthead">
      <Container text>
        <Fragment>
          <Header icon inverted>
            <Icon name="cogs" />
          </Header>
          <Header as="h1" inverted>
            CFC Academy
          </Header>
          <Header as="h2" inverted content="Site em manutenção" />
        </Fragment>
      </Container>
    </Segment>
  );
};

export default UnderMaintenance;
